import { Box, Grid, useTheme } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { EnhancedDropDownRHFWithVerifyLabel } from "../../EnhancedDropDownRHFWithVerifyLabel";
import { FC } from "react";

interface IBranchInfoSetupFieldsPanel {
	bankDDL: any;
	onVerifyBankClickedHandler: () => void;
}
export const BranchInfoSetupFieldsPanel: FC<IBranchInfoSetupFieldsPanel> = ({
	bankDDL,
	onVerifyBankClickedHandler
}) => {
	const theme = useTheme();
	return (
		<Box
			sx={{
				padding: "0",
			}}
		>
			<RHookFormMaskedTextFieldWithLabel
				label="Branch/Transit No."
				id="branchTransitNo"
				testId={`branchTransitNo`}
				labelPosition={LabelPosition.Top}
				placeholder={"00000"}
				inputMaskPattern={"00000"}
			/>
			{/* <EnhancedDropDownRHFWithLabel
				selectName="bankId"
				label="Bank No."
				labelPosition={LabelPosition.Top}
				items={bankDDL ?? []}
				testId={`bankno`}
			/> */}
			<EnhancedDropDownRHFWithVerifyLabel
				selectName="bankId"
				label={
					<>
						<Grid> Bank No&nbsp;
							<span style={{ color: theme.palette.primary.light, cursor: "pointer" }} onClick={onVerifyBankClickedHandler}>
								[Verify]
							</span>
						</Grid>
					</>
				}
				labelPosition={LabelPosition.Top}
				items={bankDDL ?? []}
				testId={`bankno`}
			/>
			<RHookFormTextFieldWithLabel
				label="Branch Address"
				id="branchAddress"
				testId={`branchAddress`}
				labelPosition={LabelPosition.Top}
			/>
		</Box>
	);
};
